<script>

import { SendRequest, ReleaseMode } from "./APIService";
import { showModal } from "./Modal";
import moment from 'moment';


let coins;
let tickets;
let exipryInHours;

let overall = true;
let limit = 0;
let multipleGiftCodesCount = 0;

let apiCalled = false;

let GiftCodeGenerated = [];


let searchGiftCodeData;

let keys = [];
let values = [];

let GiftCodeData = {
};

$: {
  keys = [];
  values = [];
    for (const [key, value] of Object.entries(GiftCodeData)) {
        keys = [...keys, key];
        values = [...values, value];
        console.log(`${key}: ${value}`);
    }
}

let boosterToAdd = "None";

// each powerup type has its own count, empty or 0 means not gifted
const powerupTypes = ["Chest", "Coin", "DoubleReward", "Xp", "OneFill", "TwoFill", "BingoStar", "SuperCharger"];
let powerupCounts = {};

function PowerupsQuery(){
    let query = '';
    for (const type of powerupTypes) {
        const count = parseInt(powerupCounts[type]) || 0;
        if (count > 0)
            query += '&' + encodeURIComponent('powerups[' + type + ']') + '=' + count;
    }
    return query;
}

function GenerateGiftCode(){
    SendRequest("GenerateGiftCode", 'POST', 'overal=' + overall + '&limit=' + limit + '&coin=' + coins + '&ticket=' + tickets + '&expiryInHours=' + exipryInHours + "&daub=" + boosterToAdd + PowerupsQuery()
    , (response) => {
        console.log("Gift Code Generated");
        GiftCodeGenerated = [];
        GiftCodeGenerated = [...GiftCodeGenerated, response];
        apiCalled = true;
    });
}

function GenerateMultipleGiftCodes(){
    SendRequest("GenerateMultipleGiftCodes", 'POST', 'coin=' + coins + '&ticket=' + tickets + '&expiryInHours=' + exipryInHours + '&amount=' + multipleGiftCodesCount + "&daub=" + boosterToAdd + PowerupsQuery()
        , (response) => {
            console.log("multiple Gift Code Generated");
            GiftCodeGenerated = response;
            apiCalled = true;
        });
    multipleGiftCodesCount = 0;
}


function SearchGiftCode(){
    SendRequest("SearchGiftCode", 'POST', 'code=' + searchGiftCodeData
    , (response) => {
        console.log("Search Gift Code Called");

        delete response.id;
        if(response.overall === true){
            delete response.limit;
            delete response.usedBy;
        }

        var x = moment(new Date(response.expiry)).from(new Date());

        response.RemainingTime = x;

        GiftCodeData = response;
    });

}

</script>

<br>
<br>
<br>

<div class="row justify-content-md-center">

    <!-- Generate Gift Code -->
    <div class="card col-md-8">
        <h5 class="card-header" style="text-align: center;"><h3>Generate Gift Code</h3></h5>

        <div class="card-body">


            <div class="mb-3 row">
                <label class="form-control"> <input type="checkbox" bind:checked={overall}> Overall</label>
            </div>

            {#if overall === false}

                <div class="mb-3 row">
                    <label  class="form-label">Limit</label>
                    <input type="number" class="form-control" placeholder="Limit. eg 1, 100 etc" bind:value={limit}>

                </div>

            {/if}


            <div class="mb-3 row">
                <label  class="form-label">Coins</label>
                <input type="number" class="form-control" placeholder="Coins" bind:value={coins}>
            </div>
            <div class="mb-3 row">
                <label  class="form-label">Tickets</label>
                <input type="number" class="form-control" placeholder="Tickets" bind:value={tickets}>
            </div>
            <div class="mb-3 row">
                <label  class="form-label">Expiry</label>
                <input type="number" class="form-control" placeholder="Hours" bind:value={exipryInHours}>
            </div>

            <div class="row g-3 mb-3">
                <div class="col-md-6">
                    <div class="card h-100 m-0">
                        <div class="card-body">
                            <label class="form-label">Daub Alert</label>
                            <select class="form-select" bind:value={boosterToAdd}>
                                <option value="None" >None</option>
                                <option value="DaubAlert2NewIran" >DaubAlert2NewIran (1.6)</option>
                                <option value="DaubAlert3" >DaubAlert3 (2.00:00:00)</option>
                                <option value="DaubAlert1Hour" >DaubAlert1Hour (01:00:00)</option>
                                <option value="DaubAlert3NewIran" >DaubAlert3NewIran (2.22:00:00)</option>
                                <option value="DaubAlert2" >DaubAlert2 (1.00:00:00)</option>
                                <option value="DaubAlert2Hour" >DaubAlert2Hour (02:00:00)</option>
                                <option value="DaubAlert1" >DaubAlert1 (03:00:00)</option>
                                <option value="DaubAlert1NewIran" >DaubAlert1NewIran (04:00:00)</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <label class="form-label">Powerups</label>
            <div class="row g-3 mb-3">
                {#each powerupTypes as type}
                    <div class="col-6 col-md-3">
                        <div class="card h-100 m-0">
                            <div class="card-body">
                                <label class="form-label">{type}</label>
                                <input type="number" min="0" class="form-control" placeholder="Count" bind:value={powerupCounts[type]}>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>

            {#if limit === 1}
                <div class="mb-3 row">
                    <label  class="form-label">Multiple Gift Coins</label>
                    <input type="number" class="form-control" placeholder="Gift Codes Count" bind:value={multipleGiftCodesCount}>
                </div>
            {/if}


            {#if !multipleGiftCodesCount || multipleGiftCodesCount === 0}
                <div class="mb-3 row">
                    <button class="btn btn-danger" type="button" on:click={GenerateGiftCode}>Generate</button>
                </div>
            {:else}
                <div class="mb-3 row">
                    <button class="btn btn-danger" type="button" on:click={GenerateMultipleGiftCodes}>Generate Multiple Gift Coins</button>
                </div>
            {/if}


            {#if apiCalled === true}
                <div class="mb-3 row border">
                    {#each GiftCodeGenerated as prop, index}
                        <h3 style="text-align: center"><strong>{prop}</strong></h3>
                    {/each}

                </div>
            {/if}
            
        </div>
    </div>

    

</div>

<br>
<br>
<br>

<!-- Search Gift Code -->
<div class="row justify-content-md-center">
    <div class="card col-md-8">
        <h5 class="card-header" style="text-align: center;"><h3>Search Gift Code</h3></h5>

        <div class="card-body">
            <div class="mb-3 row">
                <input type="text" class="form-control" placeholder="Gift Code" bind:value={searchGiftCodeData}>
            </div>
            <div class="mb-3 row">
                <button class="btn btn-danger" type="button" on:click={SearchGiftCode}>Search</button>
            </div>
        </div>
    </div>
</div>


{#if keys.length > 0 }

<div class="row justify-content-md-center">

    <div class="card col-md-8">
        <div class="card-header">
          <h3>Gift Code</h3> 
        </div>
        <div class="card-body">
            <table class="table table-bordered table-hover">
                <thead>
                    <tr>
                      <th scope="col">Item</th>
                      <th scope="col">Value</th>
                    </tr>
                  </thead>
                <tbody>
                {#each keys as prop, index}
                  <tr>
                    <!-- <th scope="row">1</th> -->
                    <td>{prop}</td>
                    <td>{JSON.stringify(values[index])}</td>
                  </tr>
                {/each}
                </tbody>
            </table>
        </div>
    </div>
    
</div>
{/if}

<style>
    .table td, .table th 
    {
        word-wrap: break-word;
        min-width: 160px;
        max-width: 160px;
    }


    .card{
        margin: 5px;
    }
  
</style>